import 'babel-polyfill'
import 'promise-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ELEMENT from 'element-ui'
import 'animate.css/animate.css'
import 'reset-css/reset.css'
import '@/assets/icons/icon-base/style.css'
import '@/assets/icons/icon-font/iconfont.css'
import '@/assets/icons/icon-entity/style.css'
import store from './store'
import uploader from 'vue-simple-uploader'
import './assets/_base.scss'
import './assets/_skin.scss'
import './assets/_common.scss'
import '@/styles/specialtool.scss'
import '@/styles/map.scss'


import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import "leaflet.markercluster/dist/leaflet.markercluster.js"


//因iclient-leaflet加载需依赖echarts、mapv，暂时将库添加至首屏加载
import echarts from 'echarts'
// import mapv from 'mapv'

import './router/manage'

Vue.use(ELEMENT);
Vue.use(uploader)

Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.config.devtools = true

//全局事件总线
window.EventBus = new Vue();

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
	document.title = to.meta.title
}
	next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js